
  <div class="pe-se-title">
    Footer
  </div>
  <mat-form-field class="pe-se-input">
    <mat-label>Background Color</mat-label>
    <input matInput
           [(ngModel)]="footer.bgColor"
           [(colorPicker)]="footer.bgColor"
           [style.background]="footer.bgColor">
  </mat-form-field>
  <mat-form-field class="pe-se-input">
    <mat-label>Link Color</mat-label>
    <input matInput
           [(ngModel)]="footer.colorLink"
           [(colorPicker)]="footer.colorLink"
           [style.background]="footer.colorLink">
  </mat-form-field>
  <div class="pe-se-input">
    <mat-label>Padding On Sides</mat-label>
    <mat-slider class="pe-se-slider"
                [(ngModel)]="footer.paddingOnSides"
                thumbLabel
                tickInterval="1"
                min="10"
                max="300"></mat-slider>
  </div>

  <div class="pe-se-title">
    Social Links
  </div>
  <mat-form-field class="pe-se-input">
    <input matInput [(ngModel)]="socialLink.FacebookUrl"/>
    <span matPrefix>https://www.facebook.com/ </span>
  </mat-form-field>
  <mat-form-field class="pe-se-input">
    <span matPrefix>https://twitter.com/ </span>
    <input matInput [(ngModel)]="socialLink.TwitterUrl"/>
  </mat-form-field>
  <mat-form-field class="pe-se-input">
    <span matPrefix>https://www.instagram.com/  </span>
    <input matInput [(ngModel)]="socialLink.InstagramUrl"/>
  </mat-form-field>
  <mat-form-field class="pe-se-input">
    <span matPrefix>https://www.youtube.com/ </span>
    <input matInput [(ngModel)]="socialLink.YouTubeUrl"/>
  </mat-form-field>
